import { ActivityLogSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

import { MallShippingLogsSortField } from "../urls";

export function getSortQueryField(
  sort: MallShippingLogsSortField
): ActivityLogSortField {
  switch (sort) {
    case MallShippingLogsSortField.created_date:
      return ActivityLogSortField.CREATED_AT;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
